'use client';

import { usePathname } from 'next/navigation';

export default function ConditionalSidebar({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  
  // Logic: Hide the sidebar for any sub-page of blog or projects
  const isDetailPage = /^\/(blog|projects)\/.+/.test(pathname);

  if (isDetailPage) return null;

  return (
    <aside className="hidden lg:block w-80 flex-shrink-0 border-r border-zinc-100 dark:border-zinc-900 sticky top-0 h-screen overflow-hidden">
      {children}
    </aside>
  );
}